import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom, Observable } from 'rxjs';
import { AuthApiService } from '../apis/auth-api.service';
import { CapacitorStorageService } from '../lib/capacitor-storage.service';
import { LocalStorageService } from '../lib/local-storage.service';
import { UiService } from '../lib/ui.service';
import { Source } from '../model/source';
import * as AppSelectors from '../store/selectors/app.selectors';
import * as AppActions from './../store/actions/app.actions';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private storage: LocalStorageService,
    private capacitorStorage: CapacitorStorageService,
    private uiService: UiService,
    private authApiService: AuthApiService,
    private store: Store<{ date: Date, sources: Source[] }>,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }

  restaurantId$: Observable<number> = this.store.pipe(select(AppSelectors.selectRestaurantId));

  async logout(keepCredentials: boolean = true) {
    const restaurantId = await firstValueFrom(this.restaurantId$);

    this.spinner.show();
    try {
      await firstValueFrom(this.authApiService.logout(`${restaurantId}`));
    } catch(err) {
      console.error("failed to logout", err);
    }
    this.spinner.hide();

    this.storage.clear();
    this.store.dispatch({ type: AppActions.logout.type });
    if (keepCredentials) {
      this.capacitorStorage.clearButLeaveCredentials();
    } else {
      this.capacitorStorage.clear();
    }
    this.uiService.closeMenu();
    this.router.navigate(["/auth/login"]);
  }
}
